var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 13C12.5522 13 12.9999 12.5523 12.9999 12C12.9999 11.4477 12.5522 11 11.9999 11C11.4477 11 10.9999 11.4477 10.9999 12C10.9999 12.5523 11.4477 13 11.9999 13Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 13C19.5522 13 19.9999 12.5523 19.9999 12C19.9999 11.4477 19.5522 11 18.9999 11C18.4477 11 17.9999 11.4477 17.9999 12C17.9999 12.5523 18.4477 13 18.9999 13Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99994 13C5.55222 13 5.99994 12.5523 5.99994 12C5.99994 11.4477 5.55222 11 4.99994 11C4.44765 11 3.99994 11.4477 3.99994 12C3.99994 12.5523 4.44765 13 4.99994 13Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontal);
export default __webpack_public_path__ + "static/media/horizontal.e8b3c7ede7b2410d6525d1cc14b04546.svg";
export { ForwardRef as ReactComponent };